/**
 * Dados mock da POC. Tudo aqui some quando a API da TSI entrar
 * (ver docs/arquitetura/visao-geral.md e docs/plano/v1-passos.md).
 */
export { mockCards } from "./mockCards";
export { mockSales, SALE_PARTNERS_LIST } from "./mockSales";
export { mockPurchases } from "./mockPurchases";

/** Data em que os mocks foram congelados. O relógio do app é fixado nela. */
export const MOCK_NOW = "2026-05-09T18:00:00Z";
